// extracted by mini-css-extract-plugin
export default {"innerContainer":"LinkDisplay_innerContainer__t6E3P","copyLabel":"LinkDisplay_copyLabel__s3l1O"};